<script>
    import Button from "./Button.svelte";
    import List from "./List.svelte";
    import ListItem from "./ListItem.svelte";
    import windows, { availableWindows } from "../../stores/windows.js";
    import t from "../../localization/t.js";

    let list;
    let isListVisible = false;

    const selectableWindows = availableWindows.filter(({ isHidden, kind }) => {
        if (kind === "talkie" && typeof AudioContext === "undefined") {
            return false;
        }

        return !isHidden;
    });

    function didClickButton() {
        isListVisible = !isListVisible;
    }

    function didClickListItem(window) {
        isListVisible = false;
        windows.focus(windows.open(window.kind));
    }

    function didMouseDownWindow(e) {
        if (!isListVisible) {
            return;
        }

        if (e.target.nodeName === "B") {
            return;
        }

        if (e.target.nodeName === "BUTTON") {
            return;
        }

        const isOutside = (() => {
            let parent = e.target;

            while (parent && parent.nodeName !== "BODY") {
                if (parent === list) {
                    return false;
                }

                parent = parent.parentNode;
            }

            return true;
        })();

        if (isOutside) {
            isListVisible = false;
        }
    }
</script>

<svelte:window on:mousedown={didMouseDownWindow} />

<div class="launcher">
    <div class="button">
        <Button isPressed={isListVisible} action={didClickButton}>
            <b>{t("applications")}</b>
        </Button>
    </div>

    {#if isListVisible}
        <div class="list" bind:this={list}>
            <List>
                {#each selectableWindows as window}
                    <ListItem
                        title={window.title}
                        action={() => didClickListItem(window)}
                    />
                {/each}
            </List>
        </div>
    {/if}
</div>

<style>
    .launcher {
        position: fixed;
        top: 20px;
        left: 20px;
        z-index: 20000;
    }

    @media only screen and (max-width: 734px) {
        .launcher {
            top: unset;
            bottom: 20px;
        }
    }

    .button {
        display: inline-block;
        box-shadow: calc(var(--chrome-depth) * 2) calc(var(--chrome-depth) * 2)
            rgba(0, 0, 0, 0.5);
    }

    b {
        display: block;
        padding: 2px 0;
    }

    .list {
        margin-top: 10px;
    }

    @media only screen and (max-width: 734px) {
        .list {
            position: absolute;
            bottom: 40px;
        }
    }
</style>
